export default __webpack_public_path__ + "static/media/insights-filled.3e139cc5.svg";